import { ReactElement } from 'react'
import { useMappingMedia } from 'app/components/mapping-media/useMappingMedia'
import {
  MappingMediaShadcnComponent,
  getMappingMediaShadcnColumns,
} from 'app/components/mapping-media/MappingMediaShadcnComponent'

export default function Media(): ReactElement {
  const { media, loading, canEditMapping, onAdd, onEdit, onDelete } = useMappingMedia(getMappingMediaShadcnColumns)

  return (
    <MappingMediaShadcnComponent
      media={media}
      loading={loading}
      canEditMapping={canEditMapping}
      onAdd={onAdd}
      onEdit={onEdit}
      onDelete={onDelete}
    />
  )
}
